import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import Search from '@/components/SearchV3/index.vue';
import { moduleOptions, statusOptions } from './options.js';
import { v2Host } from '@/config/host';
import { downloadWithNewWindow } from '@/common/download.js';
import qs from 'qs';
import { mapState } from 'vuex';

export default {
  props: {
    query: {
      type: Object,
      required: true
    },
    timeZoneList: {
      type: Array,
      required: true
    },
    handleSearch: {
      type: Function,
      required: true
    },

    handleResetSearch: {
      type: Function,
      required: true
    }
  },
  components: {
    Search: Search
  },
  data: function data() {
    return {};
  },

  computed: _extends({}, mapState({
    advOptions: function advOptions(state) {
      return state.advertiser.options || {};
    }
  }), {
    formItem: function formItem() {
      return [{
        prop: 'adv_id',
        type: 'business',
        subtype: 'advertiser-selector',
        params: {
          filterable: true,
          clearable: true,
          style: 'width: 220px;',
          placeholder: '请选择广告主'
        }
      }, {
        prop: 'timezone',
        type: 'select',
        params: {
          clearable: true,
          filterable: true,
          style: 'width: 220px;',
          options: this.timeZoneList,
          placeholder: '请选择时区'
        }
      }, {
        prop: 'module',
        type: 'select',
        params: {
          clearable: true,
          style: 'width: 220px;',
          options: moduleOptions,
          placeholder: '请选择流量类型'
        }
      }, {
        type: 'date-picker',
        subtype: 'daterange',
        prop: 'time',
        params: {
          disabled: false,
          format: 'yyyy-MM-dd',
          valueFormat: 'yyyy-MM-dd'
        }
      }, {
        prop: 'invoice_name',
        type: 'input',
        params: {
          placeholder: '请输入发票信息名称'
        }
      }, {
        prop: 'company_name',
        type: 'input',
        params: {
          placeholder: '请输入公司名称'
        }
      }, {
        prop: 'address',
        type: 'input',
        params: {
          placeholder: '请输入地址'
        }
      }, {
        prop: 'bd',
        type: 'select',
        params: {
          clearable: true,
          filterable: true,
          style: 'width: 220px;',
          options: this.cookOptions(this.advOptions.bd || []),
          placeholder: '请选择BD'
        }
      }, {
        prop: 'bd_team',
        type: 'select',
        params: {
          clearable: true,
          filterable: true,
          style: 'width: 220px;',
          options: this.cookOptions(this.advOptions.bd_team || []),
          placeholder: '请选择BD-Team'
        }
      }, {
        prop: 'bd_am',
        type: 'select',
        params: {
          clearable: true,
          filterable: true,
          style: 'width: 220px;',
          options: this.cookOptions(this.advOptions.bd_am || []),
          placeholder: '请选择BD-AM'
        }
      }, {
        prop: 'bd_am_team',
        type: 'select',
        params: {
          clearable: true,
          filterable: true,
          style: 'width: 220px;',
          options: this.cookOptions(this.advOptions.bd_am_team || []),
          placeholder: '请选择BD-AM Team'
        }
      }, {
        prop: 'pm_adv',
        type: 'select',
        params: {
          clearable: true,
          filterable: true,
          style: 'width: 220px;',
          options: this.cookOptions(this.advOptions.pm_adv || []),
          placeholder: '请选择PM-ADV'
        }
      }, {
        prop: 'pm_adv_team',
        type: 'select',
        params: {
          clearable: true,
          filterable: true,
          style: 'width: 220px;',
          options: this.cookOptions(this.advOptions.pm_adv_team || []),
          placeholder: '请选择PM-ADV Team'
        }
      }, {
        prop: 'status',
        type: 'select',
        params: {
          clearable: true,
          style: 'width: 220px;',
          options: statusOptions.map(function (item) {
            return { label: item.value, value: item.value };
          }),
          placeholder: '请选择状态'
        }
      }];
    }
  }),
  mounted: function mounted() {
    this.$store.dispatch('advertiser/getOptions');
  },

  methods: {
    handleExport: function handleExport() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                try {
                  downloadWithNewWindow(v2Host + '/finance/bill/export?' + qs.stringify(_this.query));
                } catch (error) {
                  console.log(error);
                }

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    cookOptions: function cookOptions(options) {
      return options.map(function (item) {
        return {
          label: item.label,
          value: item.v1 || item.label
        };
      });
    }
  }
};